import { Tooltip } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import InvoiceIcon from "@/Components/Icons/InvoiceIcon";
import { fetchUnPaidTimesheet } from "@/reducers/timesheets/invoicecreation";
import { toastMessageText } from "@/utilities/CommonText";
import { showCommonToast } from "@/utilities/utils";

const InvoiceTimesheet = () => {
  const { isPremiumAccount, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );
  const { selectedSignOffIds } = useSelector(
    (state) => state.clientTimesheetAuthorised,
  );
  const dispatch = useDispatch();

  if (
    clientUserAllPermissions &&
    clientUserAllPermissions.is_allow_to_create_invoices === 0
  ) {
    return null;
  }

  return (
    <>
      <Tooltip title="Create Invoice">
        <button
          className={`tour-invoice-timesheet transition-linear flex h-[40px] items-center gap-[6px] rounded-lg border border-primary bg-lightblue px-4 font-semibold leading-[normal] text-primary hover:bg-primary hover:text-white focus:outline-none`}
          onClick={() => {
            if (selectedSignOffIds.length === 0) {
              showCommonToast(toastMessageText.noTimesheetSelected, {
                id: "no-timesheet-selected",
              });
              return;
            }
            dispatch(
              fetchUnPaidTimesheet({
                timesheet_id: selectedSignOffIds.join(","),
              }),
            );
            // dispatch(toggleInvoiceTimesheetModal(true));
          }}
        >
          <InvoiceIcon />
        </button>
      </Tooltip>
    </>
  );
};

export default InvoiceTimesheet;
